export default __webpack_public_path__ + "static/media/no_search.a529d3af.svg";